import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Memos() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [tab, setTab] = useState('announcements')
  const [activeMemo, setActiveMemo] = useState(null)
  const [acknowledged, setAcknowledged] = useState([])
  const [search, setSearch] = useState('')
  const [composing, setComposing] = useState(false)
  const [draft, setDraft] = useState({ to: 'Tiffany Gallagher', subject: '', body: '' })
  const [sent, setSent] = useState([])
  const [sentFlash, setSentFlash] = useState(false)
  const [replyText, setReplyText] = useState('')
  const [dmThread, setDmThread] = useState([
    { from: 'Me', text: 'Hi Tiffany, just wanted to check on the status of my time off request for April 23-25. Thanks!', time: 'Apr 2, 9:14am', isMe: true },
    { from: 'Tiffany Gallagher', text: 'Hi Jamie! I saw it come through — reviewing it today and will get back to you by end of day.', time: 'Apr 2, 10:30am', isMe: false },
  ])

  const memos = [
    { id: 0, from: 'Tiffany Gallagher', initials: 'TG', subject: 'Spring Schedule Change — All Staff', date: 'Today', unread: true, priority: 'important', requiresAck: true, body: 'Effective Monday, April 14th, company-wide office hours will shift to 8:00am – 4:00pm, Monday through Friday.\n\nThis change applies to all office-based staff. Field team members should check with their direct supervisor for any schedule adjustments.\n\nPlease update your availability in the system and notify your manager if this creates any scheduling conflicts.' },
    { id: 1, from: 'Tiffany Gallagher', initials: 'TG', subject: 'Employee Appreciation Week — Save the Date', date: 'Mar 30', unread: true, priority: 'general', requiresAck: false, body: 'We are so excited to announce that Employee Appreciation Week is coming up — April 22 through 26!\n\nEach day will feature something special for the whole team. Monday: Breakfast for all staff. Wednesday: Team activity. Friday: Recognition ceremony & awards.\n\nThis week is all about YOU. We are deeply grateful for each and every one of you!' },
    { id: 2, from: 'Tiffany Gallagher', initials: 'TG', subject: 'Updated Parking Policy — Action Required', date: 'Mar 25', unread: true, priority: 'policy', requiresAck: true, body: 'Please be advised that our Updated Parking Policy goes into effect on May 1, 2025.\n\nAll staff members who park in the company lot are required to register their vehicle(s) with the front office before April 30th.\n\nAction required: Please acknowledge this memo to confirm you have read and understood the new policy.' },
    { id: 3, from: 'HR System', initials: 'CS', subject: 'Timesheet Reminder — Week 13 Overdue', date: 'Mar 31', unread: false, priority: 'urgent', requiresAck: false, body: 'This is an automated reminder from Collective Staff.\n\nYour timesheet for Week 13 (March 24–28) has not yet been submitted. Please log in and submit your hours as soon as possible.\n\nTimesheets submitted late may affect payroll processing.' },
    { id: 4, from: 'Sam Rivera', initials: 'SR', subject: 'Coverage Request — April 14', date: 'Mar 29', unread: false, priority: 'general', requiresAck: false, body: "Hi team,\n\nI have a conflict on Monday, April 14th and need someone to cover my morning shift (8am–12pm). It's a light morning — mostly intake and phones.\n\nIf you're available and willing to swap, please let me know before Friday!\n\nThanks, Sam" },
  ]

  const supervisors = ['Tiffany Gallagher', 'John Gallagher', 'HR Department']

  const priorityBadge = p => {
    const map = { urgent: ['#A0392B','Urgent'], important: ['#C4843A','Important'], policy: ['#4A6B8A','Policy Update'], general: ['#6B7D6B','General'] }
    const [color, label] = map[p] || map.general
    return <span style={{padding:'2px 8px',borderRadius:8,fontSize:10,fontWeight:600,background:color+'22',color}}>{label}</span>
  }

  const allMemos = [
    ...memos,
    ...sent.map((s, i) => ({ id: 1000+i, from: 'You', initials: 'ME', subject: s.subject, date: 'Just now', unread: false, priority: 'general', requiresAck: false, body: s.body, isSent: true, to: s.to }))
  ]

  const filtered = allMemos.filter(m =>
    m.subject.toLowerCase().includes(search.toLowerCase()) ||
    m.from.toLowerCase().includes(search.toLowerCase())
  )

  const unreadCount = memos.filter(m => m.unread).length
  const selected = activeMemo !== null ? allMemos.find(m => m.id === activeMemo) : null

  function handleSend() {
    if (!draft.subject.trim() || !draft.body.trim()) return
    setSent(s => [...s, { ...draft }])
    setSentFlash(true)
    setTimeout(() => setSentFlash(false), 3000)
    setDraft({ to: 'Tiffany Gallagher', subject: '', body: '' })
    setComposing(false)
  }

  function handleDmSend() {
    if (!replyText.trim()) return
    setDmThread(t => [...t, { from: 'Me', text: replyText, time: 'Just now', isMe: true }])
    setReplyText('')
  }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Memos & Messages</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Company communications — Demo Company Co.</p>
        </div>
        {tab === 'announcements' && (
          <button onClick={() => setComposing(true)} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",display:'flex',alignItems:'center',gap:6}}>
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1 12l1.5-4L10 1l2 2-7.5 7.5L1 12z" stroke="#fff" strokeWidth="1.4" strokeLinejoin="round"/><path d="M8 3l2 2" stroke="#fff" strokeWidth="1.4"/></svg>
            New Message
          </button>
        )}
      </div>

      {/* Tabs */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {[['announcements','Announcements'],['direct','Direct Messages']].map(([key,label],i,arr)=>(
          <button key={key} onClick={()=>setTab(key)}
            style={{padding:'8px 24px',border:'none',borderRight:i<arr.length-1?'1px solid #EDE6DA':'none',background:tab===key?accent:'#fff',color:tab===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
            {label}
          </button>
        ))}
      </div>

      {sentFlash && (
        <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'10px 14px',marginBottom:14}}>
          <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>Message sent to your supervisor.</span>
        </div>
      )}

      {/* Announcements tab */}
      {tab === 'announcements' && (
        <>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:16}}>
            {[
              {label:'Unread', value:unreadCount},
              {label:'Total Received', value:'14'},
              {label:'Acknowledged', value:acknowledged.length},
              {label:'Pending Sign-off', value:memos.filter(m=>m.requiresAck&&!acknowledged.includes(m.id)).length},
            ].map(s => (
              <div key={s.label} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'12px 14px'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>{s.value}</div>
              </div>
            ))}
          </div>

          <div style={{display:'grid',gridTemplateColumns:'280px 1fr',gap:14,minHeight:480}}>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column'}}>
              <div style={{padding:'10px 14px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>Inbox</div>
                <div style={{fontSize:11,color:'#6B7D6B'}}>{allMemos.length} messages</div>
              </div>
              <div style={{padding:'8px 12px',borderBottom:'1px solid #EDE6DA'}}>
                <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search memos..." style={{width:'100%',padding:'6px 10px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',background:'#F7F2EB'}}/>
              </div>
              <div style={{flex:1,overflowY:'auto'}}>
                {filtered.map(m => (
                  <div key={m.id} onClick={()=>setActiveMemo(m.id)}
                    style={{padding:'12px 14px',borderBottom:'1px solid #EDE6DA',cursor:'pointer',borderLeft:m.unread?`3px solid ${accent}`:m.isSent?'3px solid #4A7C59':'3px solid transparent',background:activeMemo===m.id?accentBg:'transparent'}}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
                      <div style={{fontSize:12,fontWeight:m.unread?600:500,color:m.isSent?'#4A7C59':m.unread?accent:'#2B2B2B'}}>{m.isSent ? `→ ${m.to}` : m.from}</div>
                      <div style={{fontSize:10,color:'#8A9E8A'}}>{m.date}</div>
                    </div>
                    <div style={{fontSize:12,fontWeight:500,color:'#4A4A4A',marginBottom:3,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.subject}</div>
                    <div style={{fontSize:11,color:'#8A9E8A',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.body.split('\n')[0]}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column'}}>
              {selected ? (
                <>
                  <div style={{padding:'16px 20px',borderBottom:'1px solid #EDE6DA'}}>
                    <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:'#2B2B2B',fontWeight:600,marginBottom:8}}>{selected.subject}</div>
                    <div style={{display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
                      <div style={{display:'flex',alignItems:'center',gap:6}}>
                        <div style={{width:24,height:24,borderRadius:'50%',background:selected.isSent?'rgba(74,124,89,0.12)':accentLight,color:selected.isSent?'#4A7C59':accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700}}>{selected.initials}</div>
                        <span style={{fontSize:12,color:'#4A4A4A',fontWeight:500}}>{selected.isSent ? `To: ${selected.to}` : `From: ${selected.from}`}</span>
                      </div>
                      <span style={{fontSize:11,color:'#8A9E8A'}}>{selected.date}</span>
                      {!selected.isSent && priorityBadge(selected.priority)}
                      {selected.isSent && <span style={{padding:'2px 8px',borderRadius:8,fontSize:10,fontWeight:600,background:'rgba(74,124,89,0.1)',color:'#4A7C59'}}>Sent</span>}
                    </div>
                    {!selected.isSent && (
                      <div style={{display:'flex',gap:8,marginTop:12}}>
                        {['Reply','Forward','Archive'].map(a => (
                          <button key={a} style={{padding:'5px 12px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:11,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>{a}</button>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{flex:1,padding:'20px'}}>
                    {selected.body.split('\n\n').map((para,i) => (
                      <p key={i} style={{fontSize:13,color:'#4A4A4A',lineHeight:1.8,marginBottom:12}}>{para}</p>
                    ))}
                    {selected.requiresAck && (
                      <div style={{marginTop:16,padding:'12px 16px',background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                        {acknowledged.includes(selected.id) ? (
                          <div style={{display:'flex',alignItems:'center',gap:6,color:'#4A7C59',fontSize:13,fontWeight:500}}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
                            Acknowledged
                          </div>
                        ) : (
                          <>
                            <span style={{fontSize:12,color:'#4A4A4A'}}>Please confirm you have read this memo</span>
                            <button onClick={()=>setAcknowledged(a=>[...a,selected.id])} style={{padding:'6px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                              Acknowledge →
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'3rem',textAlign:'center'}}>
                  <div style={{width:48,height:48,borderRadius:'50%',background:'#F7F2EB',border:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:12}}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 4h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6l-4 2V5a1 1 0 0 1 1-1z" stroke="#D9C3A3" strokeWidth="1.5"/></svg>
                  </div>
                  <div style={{fontFamily:'Georgia,serif',fontSize:'1rem',color:'#2B2B2B',marginBottom:4}}>Select a memo to read</div>
                  <div style={{fontSize:12,color:'#8A9E8A',marginBottom:16}}>Choose from the list on the left</div>
                  <button onClick={() => setComposing(true)} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                    + New Message
                  </button>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Direct Messages tab */}
      {tab === 'direct' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column',minHeight:500}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:10}}>
            <div style={{width:32,height:32,borderRadius:'50%',background:accentBg,color:accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700}}>TG</div>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>Tiffany Gallagher</div>
              <div style={{fontSize:10,color:'#6B7D6B'}}>Administrator · Direct message</div>
            </div>
          </div>

          <div style={{flex:1,overflowY:'auto',padding:'16px',display:'flex',flexDirection:'column',gap:12,minHeight:350}}>
            {dmThread.map((msg, i) => (
              <div key={i} style={{display:'flex',flexDirection:'column',alignItems:msg.isMe?'flex-end':'flex-start'}}>
                <div style={{maxWidth:'70%',padding:'10px 14px',borderRadius:msg.isMe?'12px 12px 4px 12px':'12px 12px 12px 4px',background:msg.isMe?accent:'#F7F2EB',color:msg.isMe?'#fff':'#2B2B2B',fontSize:13,lineHeight:1.6}}>
                  {msg.text}
                </div>
                <div style={{fontSize:10,color:'#8A9E8A',marginTop:3}}>{msg.isMe?'You':'Tiffany'} · {msg.time}</div>
              </div>
            ))}
          </div>

          <div style={{padding:'12px 16px',borderTop:'1px solid #EDE6DA',display:'flex',gap:10,alignItems:'flex-end'}}>
            <textarea value={replyText} onChange={e=>setReplyText(e.target.value)}
              onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();handleDmSend()}}}
              placeholder="Message Tiffany... (Enter to send, Shift+Enter for new line)"
              rows={2} style={{flex:1,padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'none',color:'#2B2B2B'}}/>
            <button onClick={handleDmSend} disabled={!replyText.trim()}
              style={{padding:'9px 18px',background:replyText.trim()?accent:'#EDE6DA',border:'none',borderRadius:6,color:replyText.trim()?'#fff':'#8A9E8A',fontSize:12,fontWeight:600,cursor:replyText.trim()?'pointer':'default',fontFamily:"'Montserrat',sans-serif"}}>
              Send →
            </button>
          </div>
        </div>
      )}

      {/* Compose Modal */}
      {composing && (
        <div style={{position:'fixed',inset:0,background:'rgba(43,43,43,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
          <div style={{background:'#fff',borderRadius:14,width:'100%',maxWidth:540,boxShadow:'0 20px 60px rgba(43,43,43,0.2)',overflow:'hidden'}}>
            <div style={{padding:'16px 20px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',fontWeight:600,color:'#2B2B2B'}}>New Message</div>
              <button onClick={() => setComposing(false)} style={{background:'none',border:'none',fontSize:18,color:'#8A9E8A',cursor:'pointer',lineHeight:1}}>×</button>
            </div>
            <div style={{padding:'20px',display:'flex',flexDirection:'column',gap:14}}>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>To</label>
                <select value={draft.to} onChange={e=>setDraft(d=>({...d,to:e.target.value}))} style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                  {supervisors.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Subject</label>
                <input value={draft.subject} onChange={e=>setDraft(d=>({...d,subject:e.target.value}))} placeholder="Message subject..." style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
              </div>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Message</label>
                <textarea value={draft.body} onChange={e=>setDraft(d=>({...d,body:e.target.value}))} placeholder="Write your message..." rows={6} style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B',resize:'vertical'}}/>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button onClick={() => setComposing(false)} style={{padding:'8px 18px',background:'#fff',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                <button onClick={handleSend} disabled={!draft.subject.trim()||!draft.body.trim()}
                  style={{padding:'8px 20px',background:draft.subject.trim()&&draft.body.trim()?accent:'#EDE6DA',border:'none',borderRadius:6,color:draft.subject.trim()&&draft.body.trim()?'#fff':'#8A9E8A',fontSize:12,fontWeight:600,cursor:draft.subject.trim()&&draft.body.trim()?'pointer':'default',fontFamily:"'Montserrat',sans-serif",transition:'all 0.2s'}}>
                  Send Message →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}